import { ApiFile } from 'kes-common';

import State from '@/store/state';

// eslint-disable-next-line import/prefer-default-export
export const getAllRelatedFiles = (state: State): ApiFile[] => state.files;
